module.exports = __webpack_public_path__ + "static/media/man.fd9d9ef3.svg";